<template lang="pug">
  modal(ref="modal" btn-text="好的，知道了")
    .level-upgrade(slot="body")
      img.level-icon(:src="info.levelIcon")
      .level-name 恭喜升为{{ info.levelName }}
      .level-desc {{ info.upgradeDesc }}
</template>

<script>
import modal from '@/components/modal';

export default {
  components: {
    modal,
  },
  data() {
    return {
      info: {},
    };
  },
  methods: {
    open(data) {
      this.info = data || {};
      return this.$refs.modal.open();
    },
  },
};
</script>

<style lang="less" scoped>
.level-upgrade {
  text-align: center;

  .level-icon {
    width: 0.8rem;
    height: 0.8rem;
    margin-bottom: 0.15rem;
  }

  .level-name {
    font-size: 18px;
    line-height: 0.25rem;
    color: #333;
    margin-bottom: 0.1rem;
  }

  .level-desc {
    font-size: 14px;
    line-height: 0.21rem;
    color: #666;
    padding: 0 0.05rem;
  }
}
</style>
